/**
 * @file formatAttachmentDate.ts
 * @description Formats an attachment timestamp for the attachments panel.
 * Consumers: `AttachmentList` for the file row's date column, and
 * `AttachmentVersionRow` for one listed version's date, published or save.
 *
 * Attachment metadata dates arrive untyped from Firestore, so anything that is
 * not a `Timestamp` — including a plain `{ seconds }` object — reads as
 * `'Unknown date'` rather than being coerced into a wrong date.
 */

import { Timestamp } from 'firebase/firestore';

/**
 * Formats dates for display
 */
export const formatAttachmentDate = (timestamp: Timestamp | any | undefined): string => {
    if (!timestamp) {
        return 'Unknown date';
    }

    if (timestamp instanceof Timestamp) {
        return timestamp.toDate().toLocaleString();
    }

    return 'Unknown date';
};
